import * as React from 'react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { Spinner } from 'reactstrap';
import Loader from 'react-loader-advanced';
import { ConnectedRouter } from 'connected-react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ChakraProvider } from '@chakra-ui/react';

import Layout from './components/Layout';
import './custom.css';

import configureStore from './store/configureStore';
import UserProvider from './context/UserProvider';
import DefaultValueProvider from './context/DefaultValueProvider';
import AdminProvider from './context/adminProvider';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });
const store = configureStore(history);

const queryClient = new QueryClient();

export default () => (
    <Provider store={store}>
        <Loader
            show={true}
            message={
                <Spinner />
            }
        >
            <ConnectedRouter history={history}>
                <UserProvider>
                    <DefaultValueProvider>
                        <AdminProvider>
                            <ChakraProvider resetCSS={false}>
                                <QueryClientProvider client={queryClient}>
                                    <Layout />
                                </QueryClientProvider>
                            </ChakraProvider>
                        </AdminProvider>
                    </DefaultValueProvider>
                </UserProvider>
            </ConnectedRouter>
        </Loader>
    </Provider>
);
